import hash from 'hash-object'
export default {
	methods: {
		hash: function(obj, check_long_time) {
			let ret, start, end;
			start = (new Date()).getTime();
			if(typeof obj == "string" || typeof obj == "number" || typeof obj == "boolean")
				ret = hash({obj});
			else
				ret = hash({obj:JSON.stringify(obj)}, {algorithm:"md5", outputFormat:"latin1"});
			end = (new Date()).getTime();
			if(check_long_time && end-start > 30) {
				// eslint-disable-next-line
				console.log("해쉬 산출 소요시간 ("+(end-start)+" ms): ", obj);
			}
			return ret;
		}
	},
}